var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import LottieAnimation from '../ScrollLock/LottieAnimation';
import { useWindowSize } from '../../hooks/useWindowSize';
import pileSvgSource from '../../assets/images/LongHeroVideo/Pile.svg';
var TwoColumnsImageText = function (props) {
    var isAnimationFinished = useMemo(function () {
        return props.desktopPositionAnimationFinished === 'finished';
    }, [props.desktopPositionAnimationFinished]);
    var snapDesktopClasses = useMemo(function () {
        if (isAnimationFinished) {
            return 'lg:snap-center';
        }
        else {
            return 'lg:snap-center';
        }
    }, [props.desktopPositionAnimationFinished]);
    var width = useWindowSize()[0];
    var isMobile = useMemo(function () {
        return width < 1024;
    }, [width]);
    return (_jsxs("div", __assign({ className: "w-full min-h-screen flex relative lg:flex-row flex-col lg:mt-20 pt-0 snap-center lg:pt-28", id: "two-columns-image-component" }, { children: [_jsxs("div", __assign({ className: "two-columns-image-component-textWrapper" }, { children: [_jsx("p", __assign({ className: "absolute text-[12px] leading-[1.67] border-b border-enblue two-columns-image-component-heading uppercase" }, { children: props.eyebrowText }), void 0),
                    _jsx("span", __assign({ className: "flex two-columns-image-component-copy" }, { children: _jsx("p", __assign({ className: "text-left mx-auto inline-block text-enblue two-columns--paragraph" }, { children: props.headSubText }), void 0) }), void 0)] }), void 0),
            isMobile ? (_jsx("img", { src: pileSvgSource, alt: "pile-svg-animation", className: "two-columns--image ml-auto md:w-3/5 w-4/5 md:mr-[91px] mr-0" }, void 0)) : (_jsx(LottieAnimation, { desktopTopMobile: props.desktopTopMobile, lottieFile: props.lottieFile, isMobile: false, id: "long-hero-lottie-animation" }, "long-hero-lottie-animation"))] }), void 0));
};
export default TwoColumnsImageText;
